(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[725],{

/***/ "FFcw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Pinterest", function() { return Pinterest; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Pinterest = function Pinterest(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    d: "M15.0004 3C8.37306 3 3 8.37064 3 14.997C3 20.0812 6.1648 24.4185 10.6289 26.1658C10.5259 25.219 10.429 23.7591 10.6722 22.7258C10.8886 21.7903 12.0789 16.7658 12.0789 16.7658C12.0789 16.7658 11.7222 16.0467 11.7222 14.9866C11.7222 13.3207 12.6909 12.0711 13.8915 12.0711C14.9139 12.0711 15.4116 12.8387 15.4116 13.7586C15.4116 14.7867 14.7572 16.3279 14.4161 17.7507C14.1296 18.9458 15.0117 19.9193 16.1907 19.9193C18.3219 19.9193 19.9614 17.6693 19.9614 14.4241C19.9614 11.5518 17.8951 9.54498 14.952 9.54498C11.5379 9.54498 9.53648 12.1031 9.53648 14.7538C9.53648 15.7871 9.93122 16.8905 10.429 17.491C10.5268 17.6096 10.5424 17.7126 10.5103 17.8372C10.4186 18.2162 10.2177 19.0323 10.1753 19.2002C10.1208 19.4217 10.0022 19.465 9.77454 19.3629C8.2761 18.6654 7.33948 16.4751 7.33948 14.7166C7.33948 10.9305 10.0879 7.45852 15.2653 7.45852C19.4256 7.45852 22.6614 10.4225 22.6614 14.3869C22.6614 18.5191 20.0541 21.8509 16.4339 21.8509C15.2168 21.8509 14.0751 21.2183 13.6855 20.4715C13.6855 20.4715 13.0848 22.7596 12.9385 23.3221C12.6675 24.3657 11.9378 25.669 11.4452 26.4643C12.5706 26.8105 13.7608 27 14.9996 27C21.6269 27 27 21.6294 27 15.003C27 8.37237 21.6278 3.00087 14.9996 3.00087L15.0004 3Z"
  }));
};

/***/ })

}]);